import React from 'react';
import { contentNotSet, headingNotSet } from '../../../services/TemplateUtils';
import type { CarouselItemContent } from '../../template/imageCarouselTypes';
import InlineRichText from './InlineRichText';
import InlineText from './InlineText';
import { webCardBodySx, webCardTitleSx } from './webTextStyles';

interface ImageCarouselSlideContentFieldsProps {
  index: number;
  item: CarouselItemContent;
  onUpdateHeading: (value: string) => void;
  onUpdateText: (value: string) => void;
}

/** A carousel slide's title + optional description fields. */
export default function ImageCarouselSlideContentFields({
  index,
  item,
  onUpdateHeading,
  onUpdateText,
}: ImageCarouselSlideContentFieldsProps) {
  return (
    <>
      <InlineText
        value={item.heading?.content ?? ''}
        unset={headingNotSet(item.heading)}
        onChange={onUpdateHeading}
        placeholder="Add a title"
        ariaLabel={`Slide ${index + 1} title`}
        sx={webCardTitleSx}
      />
      {item.text !== undefined && (
        <InlineRichText
          html={item.text?.content ?? ''}
          unset={contentNotSet(item.text ?? null)}
          onChange={onUpdateText}
          placeholder="Add a description"
          ariaLabel={`Slide ${index + 1} description`}
          sx={webCardBodySx}
        />
      )}
    </>
  );
}
